import './App.css';
import Container from '@mui/material/Container';
import { Grid } from '@mui/material';
import Profile from './Components/Profile/Profile';
import Header from './Components/Header/Header';
import Projects from './Pages/Protfolio/Projects';
import Resume from './Pages/Resume/Resume';
import Footer from './Components/Footer/Footer';
import {BrowserRouter,Switch,Route} from 'react-router-dom'
import Contact from './Pages/Contact/Contact';
import Emailwelcome from './Pages/Emailwelcomepage/Emailwelcome';
import Particles from "react-tsparticles";
import Blog from './Pages/Blog/Blog';
function App() {

  const particlesInit = (main) => {
    console.log(main);
  
    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  };
  
  const particlesLoaded = (container) => {
    console.log(container);
  };
  
  return (
    <>
    
    <Container className="allwrapper" style={{zIndex:"1"}}>
      
        <Grid container spacing={5}>
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <Profile/>
          </Grid>
          <Grid item xs>
          <BrowserRouter> 
            <Header/>
             <div className="main-content">
              <Switch>
                <Route exact path="/">
                  <Resume/>
                </Route>
                <Route path="/projects">
                  <Projects/>
                </Route>

                <Route path="/resume">
                  <Resume/>
                </Route>
                <Route path="/contact">
                  <Contact/>
                </Route>
                <Route path="/blog">
                  <Blog/>
                </Route>
                <Route path="/success">
                  <Emailwelcome/>
                </Route>
              </Switch>
             </div>
              
              
             </BrowserRouter>
           
           
            <Footer/>
          </Grid>
         
       </Grid>

       
    </Container>

    <Particles
      
      style={{zIndex:"0"}}
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        background: {
          color: {
            value: "",
          },
        },
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40,
            },
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#fff",
          },
          links: {
            color: "red",
            distance: 150,
            enable: true,
            opacity: 0.2,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 2,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              value_area: 800,
            },
            value: 80,
          },
          opacity: {
            value: 0.3,
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 5,
          },
        },
        detectRetina: true,
      }}
    />
   
    </>
  );
}

export default App;
